// extracted by mini-css-extract-plugin
export default {"recos":"u4-z","productCardOverride":"v4-z","rowHasBadge":"w4-z"};